<template>
  <div id="app">
    <imgPlane  :url="imgUrl" :isShow="showImg" @planeVisibleEvent="showImgPlane('')"/>
    <div id="top">
    <span v-show="!isLogin">
      <el-popover
        placement="bottom"
        trigger="click">
        <span>userId：<input id="userId" ref="userId" ><button @click="login" >login</button></span>
        <el-button slot="reference">public</el-button>
      </el-popover>
    </span>
    <span v-show="isLogin">
      <input type="checkbox" id="cbHide" ref="cbHide">显示全部的内容
    </span>
    <span v-show="isLogin">
      <router-view/>
    </span>
    <span v-show="isLogin" @click="logout">退出登录</span>
    </div>
    <img id="QRCode" src="qrcode" v-show="isShowQr" @click="hideQr" alt="QRCode"/>
    <table class="displayPlane" border="1" v-if="!isLogin" v-html="tableTitle + content"></table>
    <table class="displayPlane" border="1" v-if="isLogin" v-html="tableTitleAdmin + content"></table>
    <btmBar/>
    </div>
</template>

<script>
// import imgPlane from './components/imgPlane'
import ImgPreviewer from 'img-previewer'
import btmBar from './components/btmBar'
import axios from 'axios'
axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost:3002/'
var myViewer

export default {
  name: 'App',
  components: {
    // imgPlane,
    btmBar
  },
  data () {
    return {
      // tableTitle: '<tr><th>序号</th><th>内容</th><th>提交者</th><th>日期</th><th>操作</th></tr><tr><th>序号</th><th>内容</th><th>提交者</th><th>日期</th><th><a href="http://localhost:3001/1.jpg" target=_blank><img src="http://localhost:3001/1.jpg" alt="pic" style="max-height: 500px;max-width: 500px"></th></tr>',
      tableTitleAdmin: '<tr><th>序号</th><th>内容</th><th>提交者</th><th>日期</th><th>操作</th></tr>',
      tableTitle: '<tr><th>序号</th><th>内容</th><th>提交者</th><th>日期</th></tr>',
      content: '',
      contentNum: 0,
      isLogin: false,
      isShowQr: true,
      latest: (new Date(0)).getTime().toString(),
      valueDate: '',
      showImg: false,
      imgUrl: ''
      /* lazyImg: new IntersectionObserver(entries => {
        entries.forEach((item, index) => {
          if (item.target.getAttribute('src') === 'loading') {
            item.target.setAttribute('src', item.target.getAttribute('thumbsrc'))
            // console.log('触发：' + item.target.getAttribute('thumbsrc'))
          } else {
            this.lazyImg.unobserve(item.target)
          }
        })
      }, {threshold: 0.25}) */
    }
  },
  created () {
    console.log('当前版本：1104a')
    window.scrollTo(100, 5000)
    axios.get('/init')
      .then(res => {
        if (res.data === 'ok') {
          this.isLogin = true
        }
        this.poll()
      }).catch(err => {
        console.log(err)
      })
    setInterval(() => {
      this.poll()
    }, 3000)
    window.adHide = this.adHide
    window.adDelete = this.adDelete
    window.showImgPlane = this.showImgPlane
    window.imgOnload = this.imgOnload
  },
  mounted () {
    myViewer = new ImgPreviewer('.displayPlane')
    myViewer.update()
  },
  methods: {
    hideQr: function () {
      this.isShowQr = !this.isShowQr
    },
    showImgPlane: function (imgUrl) {
      this.imgUrl = imgUrl
      // this.showImg = !this.showImg
    },
    imgOnload: function (id) {
      document.getElementById(id).classList.remove('loading-img')
      // console.log('onload：' + document.getElementById(id).classList)
    },
    login: function () {
      if (this.$refs.userId.value.length === 0) {
        return
      }
      let data = {userId: this.$refs.userId.value}
      axios.post('/login', data)
        .then(res => {
          if (res.data === 'ok') {
            this.isLogin = true
            this.poll()
          } else {
            alert('error user')
          }
        }).catch(err => {
          alert('服务器上传异常')
          console.log(err)
        })
    },
    logout: function () {
      axios.get('/logout')
        .then(res => {
          if (res.data === 'logout') {
            location.reload()
          }
        }).catch(err => {
          console.log(err)
        })
    },
    poll: function () {
      let isShowHide = this.$refs.cbHide.checked === true
        ? '&&showhide=true' : '&&showhide=false'
      let pollUrl = '/poll?latest=' + this.latest + isShowHide
      axios.get(pollUrl)
        .then(res => {
          if (res.data.content !== '') {
            this.content = res.data.content
            this.latest = res.data.latest
            // document.querySelectorAll('.content-img').forEach((imgItem) => { this.lazyImg.observe(imgItem) })
            myViewer.update()
          }
        }).catch(err => {
          console.log(err)
        })
    },
    adHide: function (num, hide) {
      let url = '/update?num=' + num + '&&hide=' + hide
      axios.get(url)
        .then(res => {
          this.poll()
        }).catch(err => {
          console.log(err)
        })
    },
    adDelete: function (num) {
      let url = '/delete?num=' + num
      axios.get(url)
        .then(res => {
          this.poll()
        }).catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#top{
  color:white;
  background:#151515;
  width:100%;
}
#top span{
  margin-right: 40px;
  display: inline-block;
}
#top span:hover{
  background:#585858;
}
#top span:last-child:hover{
  background:#151515;
}
.el-button{
  color: #424242;
}
#QRCode{
  position: fixed;
  right: 0px;
  max-width: 50%;
  border: 3px solid;
  box-shadow: -5px 10px 10px #888888;
}
table{
  font-size:25px;
  margin-top: 1px;
  margin-bottom: 10%;
  text-align:left;
}
table td img{
  max-width: 50%;
  max-height: 50%;
}
table td:nth-child(3){
  font-size:9px;
}
table td:nth-child(4){
  font-size:9px;
}
.loading-img{
  font-size: 10px;
  margin: 50px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  text-indent: -9999em;
  position: relative;
  animation: mymove 1.3s infinite linear;
  -webkit-animation: mymove 1.5s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@keyframes mymove {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em #46A4C9, 2em -2em 0 0em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 0 #46A4C9;
  }
  12.5% {
    box-shadow: 0 -3em 0 0 #46A4C9, 2em -2em 0 0.2em #46A4C9, 3em 0 0 0 #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em #46A4C9, 2em -2em 0 0 #46A4C9, 3em 0 0 0.2em #46A4C9, 2em 2em 0 0 #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0em 0 0 #46A4C9, 2em 2em 0 0.2em #46A4C9, 0 3em 0 0em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0em 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  50% {
    box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 0em #46A4C9, 0 3em 0 0.2em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 0 #46A4C9, -2em 2em 0 0.2em #46A4C9, -3em 0 0 0 #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  75% {
    box-shadow: 0em -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0em 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 0.2em #46A4C9, -2em -2em 0 0 #46A4C9;
  }
  87.5% {
    box-shadow: 0em -3em 0 0 #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 0 #46A4C9, -2em -2em 0 0.2em #46A4C9;
  }
}
@-webkit-keyframes mymove
/*Safari and Chrome*/
{
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em #46A4C9, 2em -2em 0 0em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 0 #46A4C9;
  }
  12.5% {
  box-shadow: 0 -3em 0 0 #46A4C9, 2em -2em 0 0.2em #46A4C9, 3em 0 0 0 #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  25% {
  box-shadow: 0 -3em 0 -0.5em #46A4C9, 2em -2em 0 0 #46A4C9, 3em 0 0 0.2em #46A4C9, 2em 2em 0 0 #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  37.5% {
  box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0em 0 0 #46A4C9, 2em 2em 0 0.2em #46A4C9, 0 3em 0 0em #46A4C9, -2em 2em 0 -1em #46A4C9, -3em 0em 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  50% {
  box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 0em #46A4C9, 0 3em 0 0.2em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 -1em #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  62.5% {
  box-shadow: 0 -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 0 #46A4C9, -2em 2em 0 0.2em #46A4C9, -3em 0 0 0 #46A4C9, -2em -2em 0 -1em #46A4C9;
  }
  75% {
  box-shadow: 0em -3em 0 -1em #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0em 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 0.2em #46A4C9, -2em -2em 0 0 #46A4C9;
  }
  87.5% {
  box-shadow: 0em -3em 0 0 #46A4C9, 2em -2em 0 -1em #46A4C9, 3em 0 0 -1em #46A4C9, 2em 2em 0 -1em #46A4C9, 0 3em 0 -1em #46A4C9, -2em 2em 0 0 #46A4C9, -3em 0em 0 0 #46A4C9, -2em -2em 0 0.2em #46A4C9;
  }
}
button{
  z-index:10;
}
</style>



// WEBPACK FOOTER //
// src/App.vue